import DataArrayIcon from "@mui/icons-material/DataArray";
import { Box, Button, Menu, MenuItem, SxProps, Theme } from "@mui/material";
import { useState } from "react";
import { TemplateFieldType } from "../../../../App/Enums/TemplateFieldType";
import { useGetMessageTemplateFields } from "../../../../App/Queries/MessageQueries";
import { useMessageInputHandlers } from "../../../../App/State/Hooks/MessageDialog/useMessageInput";
import { useUserProfileStore } from "../../../../App/State/Stores/UserProfileStore";

export default function MessageTemplateFields({
  handleTemplateButtonClick,
  sx,
  excludedTypes,
  excludedFields,
}: {
  handleTemplateButtonClick?: (e: any, field: string) => void;
  sx?: SxProps<Theme>;
  excludedTypes?: TemplateFieldType[];
  excludedFields?: string[];
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const { profile } = useUserProfileStore();
  const excludedFieldsWithProfile = [...(excludedFields || [])];
  if (!profile.title) {
    excludedFieldsWithProfile.push("RecruiterTitle");
  }
  const { data: templateFields, isLoading } = useGetMessageTemplateFields(
    excludedTypes,
    excludedFieldsWithProfile,
  );
  const { handleAddTemplateField } = useMessageInputHandlers();

  const handleTemplateFieldClick = (e: any, field: string) => {
    if (handleTemplateButtonClick) {
      handleTemplateButtonClick(e, field);
    } else {
      handleAddTemplateField(field);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return templateFields?.length ? (
    <Box sx={sx}>
      <Button
        disabled={isLoading}
        data-test="template-tag-menu-button"
        startIcon={<DataArrayIcon />}
        onClick={handleClick}
      >
        {isLoading ? "Loading tags" : "Template Tags"}{" "}
      </Button>
      <Menu
        id="template-tag-menu"
        data-test="template-tag-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        aria-controls={menuOpen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
        MenuListProps={{
          "aria-labelledby": "template-tag-menu-buttn",
        }}
        sx={{ maxHeight: 450 }}
      >
        {templateFields?.map((templateField: any) => (
          <MenuItem
            sx={{ minWidth: "135px" }}
            key={templateField.field}
            data-test={`template-tag-${templateField.field}`}
            onClick={(e) => {
              handleTemplateFieldClick(e, templateField.field);
              handleClose();
            }}
          >
            {templateField.field}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  ) : (
    <></>
  );
}
